import { add } from "./base";
class Handler {
    country;
    constructor(country) {
        this.country = country;
    }
    toString(data) {
        return typeof data == "string" ? data : "";
    }
    fromString(value) {
        return typeof value == "string" && !!value ? value : undefined;
    }
    partialFormat = this.format;
    format(unformatted) {
        const result = !unformatted.value.includes(" ") && unformatted.value.length >= 4 ? unformatted.insert(3, " ") : unformatted;
        return {
            ...result.truncate(6),
            type: "text",
            autocomplete: "postal-code",
            length: [6, 6],
            pattern: /^\d{3} \d{2}$/,
        };
    }
    unformat(formatted) {
        return formatted.delete(" ");
    }
    allowed(symbol, state) {
        return state.value.length <= 5 && symbol >= "0" && symbol <= "9";
    }
}
add("postal-code", (argument) => new Handler(argument && argument.length > 0 ? argument[0] : undefined));
//# sourceMappingURL=postal-code.js.map